export function findParentBlockInBlocks(childBlockId, blocks, blocksContainer = false) {
	let foundParent;
	for (let block of blocks) {
		if (childBlockId === block.id) {
			foundParent = blocksContainer;
		} else if (block.hasOwnProperty('blocks')) {
			// If block have "blocks" means that it is not a valid block type (its parent is the valid one)
			foundParent = findParentBlockInBlocks(childBlockId, block.blocks, blocksContainer);
		} else if (block.type === 'carousel') {
			foundParent = findParentBlockInBlocks(childBlockId, block.data.cards, block);
		} else if (block.type === 'tabs') {
			foundParent = findParentBlockInBlocks(childBlockId, block.data.tabs, block);
		} else if (block.type === 'flipCardEnhanced') {
			foundParent = findParentBlockInBlocks(childBlockId, [block.data.front, block.data.back], block);
		} else if (block.type === 'flashCard') {
			foundParent = findParentBlockInBlocks(childBlockId, block.data.blocks, block);
			if (!foundParent) {
				foundParent = findParentBlockInBlocks(childBlockId, block.data.overlays.answer.blocks, block);
			}
		} else if (block.type === 'libraryContentCustom') {
			foundParent = findParentBlockInBlocks(childBlockId, block.data.blocks, block);
			if (!foundParent) {
				foundParent = findParentBlockInBlocks(childBlockId, block.data.overlays.expanded.blocks, block);
			}
		} else if (
			block.type === 'contentMultipleChoiceQuestion' ||
			block.type === 'contentMultipleChoiceQuestionTemplate' ||
			block.type === 'adaptiveLearningResult'
		) {
			foundParent = findParentBlockInBlocks(childBlockId, block.data.blocks, block);
			if (!foundParent && block.data.overlays) {
				// Try to find block in correct overlay
				foundParent = findParentBlockInBlocks(childBlockId, block.data.overlays.correct.blocks, block);
			}
			if (!foundParent && block.data.overlays) {
				// Try to find block in incorrect overlay
				foundParent = findParentBlockInBlocks(childBlockId, block.data.overlays.incorrect.blocks, block);
			}
		}

		if (block.actions && !foundParent) {
			const popup = block.actions.find(action => action.type === 'popup');
			if (popup) {
				foundParent = popup.id === childBlockId ? block : findParentBlockInBlocks(childBlockId, popup.blocks, block);
			}
		}

		if (foundParent) return foundParent;
	}
}